<div *ngIf="source === 'duplicate'">
  <nz-table #basicTable [nzData]="dataList">
    <thead>
      <tr>
        <th scope="col">
          <div>
            <input
              type="checkbox"
              [(ngModel)]="checked"
              (change)="onAllChecked($event)"
            />
          </div>
        </th>
        <th scope="col">Test Case ID</th>
        <th scope="col">Test Case Name</th>
        <th scope="col">Test Case Description</th>
        <th scope="col">Remarks</th>
        <th scope="col">Recommendations</th>
      </tr>
    </thead>
    <tbody>
      @for (data of basicTable.data; track data) {
      <tr [ngClass]="{ unique: data.isUnique || data.isDefault }">
        <td>
          <input type="checkbox" [(ngModel)]="data.checked" (change)="onItemChecked(data, $event)"/>
        </td>
        <td>{{ data.testId }}</td>
        <td>{{ data.testName }}</td>
        <td> {{ data.description }} </td>
        <td> {{ data.remarks }} </td>
        <td>
          <div *ngIf="data.isDefault" class="d-flex align-items-center justify-content-between">
            <span class="system-default">
              * System recommends 'Unique' and it is pre-checked by default
            </span>
             <div class="d-flex align-items-center">
              <div class="form-check form-switch mx-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                  [(ngModel)]="data.isUnique"
                />
              </div>
            </div>
          </div>
          <div *ngIf="!data.isDefault" class="d-flex align-items-center justify-content-between">
            <span> Enable as Unique Recommendation </span>
            <div class="d-flex align-items-center">
              <div class="form-check form-switch mx-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                  [(ngModel)]="data.isUnique"
                  checked
                />
              </div>
            </div>
          </div>
        </td>
      </tr>
      }
    </tbody>
  </nz-table>
</div>

<!-- Overlap Table -->
<div *ngIf="source === 'overlap'">
  <nz-table #basicTable [nzData]="dataList">
    <thead>
      <tr>
        <th scope="col">
          <div>
            <input
              type="checkbox"
              [(ngModel)]="checked"
              (change)="onAllChecked($event)"
            />
          </div>
        </th>
        <th scope="col">Cluster Name</th>
        <th scope="col">1st Test Case Name</th>
        <th scope="col">2nd Test Case Name</th>
        <th scope="col">Similarity Score (Steps)</th>
        <th scope="col">Similarity Score (Expected Result)</th>
      </tr>
    </thead>
    <tbody>
      @for (data of basicTable.data; track data) {
      <tr>
        <td>
          <input type="checkbox" [(ngModel)]="data.checked" (change)="oneItemCheckedAtOnce(data, $event)"/>
        </td>
        <td> {{ data.clusterId }} </td>
        <td>{{ data.baseTestName }}</td>
        <td>{{ data.comparedTestName }}</td>
        <td> {{ data.stepDescScore }} </td>
        <td> {{ data.expResultScore }} </td>
      </tr>
      }
    </tbody>
  </nz-table>
</div>

<!-- Unique Table -->
<div *ngIf="source === 'unique'">
  <nz-table #basicTable [nzData]="dataList">
    <thead>
      <tr>
        <th scope="col">
          <div>
            <input
              type="checkbox"
              [(ngModel)]="checked"
              (change)="onAllChecked($event)"
            />
          </div>
        </th>
        <th scope="col">S.No</th>
        <th scope="col">Test Case ID</th>
        <th scope="col">Test Case Name</th>
        <th scope="col">Test Case Description</th>
        <th scope="col">Expected Results</th>
      </tr>
    </thead>
    <tbody>
      @for (data of basicTable.data; track data) {
      <tr>
        <td>
          <input type="checkbox" [(ngModel)]="data.checked" (change)="onItemChecked(data, $event)"/>
        </td>
        <td>1</td>
        <td>{{ data.name }}</td>
        <td>{{ data.age }}</td>
        <td>{{ data.address }}</td>
        <td>bajkds</td>
      </tr>
      }
    </tbody>
  </nz-table>
</div>
